import config from "@/config";
import i18n from "@/languages";
import { library } from "@fortawesome/fontawesome-svg-core";
// internal icons
import '@fontsource/inter';

import {
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faAngleUp,
    faArrowUp,
    faCalendarDay,
    faCaretDown,
    faCaretUp,
    faCheck,
    faCheckCircle,
    faExclamationCircle,
    faExclamationTriangle,
    faEye,
    faEyeSlash,
    faInfoCircle,
    faMinus,
    faPencilRuler,
    faPlus,
    faPlusCircle,
    faTag,
    faTrash,
    faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { Integrations } from "@sentry/tracing";
import * as Sentry from "@sentry/vue";
import Buefy from "buefy";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import Vue from "vue";
import InputFacade from "vue-input-facade";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./vee-validate";

Sentry.init({
    Vue: Vue,
    dsn: config.sentryDsn,
    environment: process.env.NODE_ENV,
    integrations: [new Integrations.BrowserTracing()],
    logErrors: true,

    // Ruido benigno del navegador, no bugs de la app: el "loop" de
    // ResizeObserver se completa en el frame siguiente (no rompe nada) pero
    // burbujea a window.onerror. Lo dispara, p.ej., la tabla de evolución
    // (ResizeObserver sobre document.body que recalcula su max-height).
    // Filtrarlo es la recomendación oficial de Sentry para este mensaje.
    // Ref: https://github.com/WICG/resize-observer/issues/38
    ignoreErrors: [
        "ResizeObserver loop limit exceeded",
        "ResizeObserver loop completed with undelivered notifications",
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.2,
    tracingOptions: {
        trackComponents: true,
    },
});

library.add(
    faCheck,
    faCheckCircle,
    faInfoCircle,
    faExclamationTriangle,
    faExclamationCircle,
    faArrowUp,
    faAngleRight,
    faAngleLeft,
    faAngleDown,
    faAngleUp,
    faEye,
    faEyeSlash,
    faCaretDown,
    faCaretUp,
    faUpload,
    faCalendarDay,
    faPlus,
    faMinus,
    faPlusCircle,
    faTag,
    faPencilRuler,
    faTrash
);

Vue.component("vue-fontawesome", FontAwesomeIcon);

const options = {
    // rename the directive from: v-facade to: v-mask
    name: "mask",

    // use these tokens instead of the default
    tokens: {
        "#": {
            pattern: /\d/,
        },
        A: {
            pattern: /[a-z]/i,
        },
        N: {
            pattern: /[0-9a-z]/i,
        },
        X: {
            pattern: /./,
        },
        B: {
            pattern: /[0-9kK]/i,
        },
    },
};

Vue.use(InputFacade, options);
Vue.use(Buefy, {
    defaultIconComponent: "vue-fontawesome",
    defaultIconPack: "fas",
});
// Tooltips via Floating UI — reemplaza @creativebulma/bulma-tooltip.
// El theme 'sidebar-tooltip' extiende el default (negro Bulma) y se aplica
// vía v-tooltip="{ content, theme: 'sidebar-tooltip' }" en SidebarNavItem
// y SidebarUserSection.
Vue.use(FloatingVue, {
    themes: {
        "sidebar-tooltip": {
            $extend: "tooltip",
            placement: "right",
        },
    },
});
Vue.config.productionTip = false;
Vue.config.devtools = true;

new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
